import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const AttachmentIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    {...props}
  >
    <Path
      d="M12 3.41667V13.75C12 15.4069 10.6569 16.75 9 16.75H7C5.34315 16.75 4 15.4069 4 13.75V2.75C4 1.64543 4.89543 0.75 6 0.75L6.66667 0.75L7.33333 0.75C8.4379 0.75 9.33333 1.64543 9.33333 2.75V13.0833C9.33333 13.6356 8.88562 14.0833 8.33333 14.0833H7.66667C7.11438 14.0833 6.66667 13.6356 6.66667 13.0833V3.41667"
      stroke={color}
      strokeWidth="1.5"
    />
  </Svg>
);

AttachmentIcon.displayName = 'AttachmentIcon';
